export const DATA_FIRESTORE_V01_USERS_PUBLIC = {
  NAME: 'v01_users_public',
  FIELDS: {
    USER_NAME: {
      KEY: 'userName',
      VALUES: {
        DEFAULT: null,
      },
    },

    USER_EMAIL: {
      KEY: 'userEmail',
      VALUES: {
        DEFAULT: null,
      },
    },

    USER_TYPE: {
      KEY: 'userType',
      VALUES: {
        COMPETITOR: 'competitor',
        STAFF: 'staff',
        ORGANIZER: 'organizer',
        VENDOR: 'vendor',
        UNDEFINED: 'undefined',
      },
    },

    USER_NAME_NGRAMS: {
      KEY: 'userNameNGram',
      VALUES: {
        UNKNOWN: 'Unknown',
      },
    },
  },
}
